import React from "react";

import Grid from "@busbud/design-system-components/dist/Grid/Grid";

import { useAppContext } from "@app/helpers/hooks";

import { HepstarTermChip, UNDER_CONDITIONS } from "./hepstar-terms-chip";

export const HepstarTermsUnderConditionsChips = () => {
  const { translator } = useAppContext();

  return (
    <Grid>
      <HepstarTermChip
        category={UNDER_CONDITIONS}
        label={translator.t(
          "!ancillary.hepstar.terms.under-conditions.covid-19"
        )}
      />
    </Grid>
  );
};
